import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../store";
import { setError } from "../features/msp/slices/apiStatusSlice";
import type { CustomerInformation } from "../features/common/types";
import { fetchCustomerInformation } from "../features/customer/services/customerService";

export const useCustomerData = (mspId: number, customerId: number) => {
  const dispatch = useDispatch<AppDispatch>();
  const [customer, setCustomer] = useState<CustomerInformation | null>(null);

  const fetchData = useCallback(async () => {
    if (!customerId || customerId <= 0) return;
    try {
      const resp = await fetchCustomerInformation(mspId, customerId);
      console.log("fetchCustomerInformation response:", resp);
      setCustomer(resp?.data ?? null);
    } catch (err) {
      dispatch(setError("Failed to fetch customer data"));
    }
  }, [dispatch, customerId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { customer, fetchData } as const;
};
